module.exports = __webpack_public_path__ + "ba461376cc13d9511053574fdf29d0e6.png";